import React, { useCallback } from "react";
import AuthHeader from "../components/Headers/AuthHeader.component";
import Footer1 from "../components/Footers/Footer1.component";

import { useState } from "react";

import PendingJobs from "../components/Jobs/PendingJobs.component";
import InProgressJobs from "../components/Jobs/InProgressJobs.component";
import CompletedJobs from "../components/Jobs/CompletedJobs.component";
import { useSelector } from "react-redux";

export default function MyJobs() {
  
  const userData = useSelector(state => state.auth.data);
  
  const [tab, setTab] = useState(userData?.role == 2 ? 2 : 1);


  return (
    <>
      <AuthHeader />
      
        <section className="bds-main-section bg-gray">
          <div className="container">
            <div className="row">
              <div className="col-xl-8">
                <div className="bds-sectiontitle">
                  <div className="bds-featureRating">
                    <h3 className="mb-3">My Jobs</h3>
                    <p>
                    All Jobs will be listed here. You can switch to get related jobs by Topping on below buttons
                    </p>
                  </div>

                  <ul
                    className="nav nav-pills mt-5 mb-3 bds-tabs-container"
                    id="pills-tab"
                    role="tablist"
                  >
                    {
                      userData?.role == 3 &&
                        <li className="nav-item" role="presentation">
                          <button
                            className={`nav-link text-dark px-0 me-4 rounded-0 fw-bold ${tab == 1 ? "active" : ""
                              }`}
                            onClick={() => setTab(1)}
                          >
                            Pending
                          </button>
                        </li>
                    } 
                    <li className="nav-item" role="presentation">
                      <button
                        className={`nav-link text-dark px-0 me-4 rounded-0 fw-bold ${
                          tab == 2 ? "active" : ""
                        }`}
                        onClick={() => setTab(2)}
                      >
                        In Progress
                      </button>
                    </li>                    
                    
                    <li className="nav-item" role="presentation">
                      <button
                        className={`nav-link text-dark px-0 me-4 rounded-0 fw-bold ${
                          tab == 3 ? "active" : ""
                        }`}
                        onClick={() => setTab(3)}
                      >
                        Completed
                      </button>
                    </li>
                    
                  </ul>
                  <div>
                    {tab == 1 && (
                      <PendingJobs />
                    )}

                    {tab == 2 && (
                      <InProgressJobs />
                    )}

                    {tab == 3 && (
                      <CompletedJobs />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      
      <Footer1 />
    </>
  );
}
